const strings = {
  'notifications/submission/badPlayerData/title': {
    en: 'Player unavailable',
    fr: 'Joueur non disponible',
  },
  'notifications/submission/badPlayerData/text': {
    en: 'Sorry, some of your picks have already hit the ice and are no longer available. Please update your picks and try again.',
    fr: 'Désolé, certaines de vos sélections ne sont plus disponibles. Veuillez modifier vos choix et réessayer.',
  },
  'notifications/games/inProgress/title': {
    en: 'Games in progress.',
    fr: 'Matchs en cours.',
  },
  'notifications/games/allInProgress/title': {
    en: 'Selection period closed.',
    fr: 'La période de sélection est fermée.',
  },
  'notifications/games/inProgress/text': {
    en: 'You will not be able to pick players in games that have started.',
    fr: 'Vous ne pourrez pas sélectionner de joueurs pour les matchs qui sont commencés.',
  },
  'notifications/games/allInProgress/text': {
    en: "All of today's games have started. Picks will not be accepted at this time.",
    fr: 'Tous les matchs d’aujourd’hui sont commencés. Les choix ne sont pas acceptés à ce stade-ci.',
  },
  'notifications/games/welcome/title': {
    en: 'Welcome to the Tim Hortons NHL Hockey Challenge™',
    fr: 'Bienvenue au Défi de hockey de la LNH<sup>MD</sup> de Tim!',
  },
  'notifications/games/welcome/text': {
    en: "Pick 3 players who you think will score in today's games. If they find the back of the net, you score!",
    fr: 'Choisissez 3 joueurs qui, selon vous, marqueront un but dans les matchs d’aujourd’hui. S’ils trouvent le fond du filet, vous marquez!',
  },
  'notifications/games/picksFilled/title': {
    en: 'Your lineup has been filled!',
    fr: 'Votre sélection est complète!',
  },
  'notifications/games/picksFilled/text': {
    en: "Tap 'Submit picks' to lock in your picks.",
    fr: 'Enregistrez vos choix en appuyant sur ”Soumettre vos choix”',
  },
  'notifications/games/noGames/title': {
    en: 'There are no games today',
    fr: 'Aucun match n’est prévu aujourd’hui',
  },
  'notifications/games/noGames/text': {
    en: 'There are no games today',
    fr: 'Aucun match n’est prévu aujourd’hui',
  },
  'notifications/games/noGames/sub-text': {
    en: 'Come back on game day to make your picks!',
    fr: 'Revenez le jour du match pour faire vos choix!',
  },
  'notifications/confirmPicks/text': {
    en: 'Picks cannot be changed once submitted.',
    fr: 'Les choix de joueurs ne peuvent pas être modifiés une fois soumis.',
  },
  'notifications/submitted/text': {
    en: 'See which players have scored <a target="_parent" href="https://www.nhl.com/scores/">on NHL.com</a>!',
    fr: 'Découvrez les joueurs qui ont marqué un but à <a target="_parent" href="https://www.nhl.com//fr/scores/">NHL.com</a>!',
  },
  'notifications/quiz/wrongAnswer/title': {
    en: 'Wrong answer',
    fr: 'Mauvaise réponse',
  },
  'notifications/quiz/wrongAnswer/text': {
    en: 'Please try solving the new question below',
    fr: 'Veuillez résoudre la nouvelle question ci-dessous',
  },
  'notifications/quiz/gameLocked/title': {
    en: 'Please try again later',
    fr: 'Veuillez réessayer plus tard.',
  },
  'notifications/quiz/gameLocked/text': {
    en: 'Sorry, the answers you gave to the skill-testing question were incorrect. Please wait 48 hours and try again.',
    fr: 'Malheureusement, les réponses que vous avez fournies à la question réglementaire sont incorrectes. Veuillez attendre 48 heures avant de réessayer.',
  },
  'notifications/quiz/gameLocked/checkBack/text': {
    en: 'Check back soon!',
    fr: 'Revenez bientôt!',
  },
  'notifications/tierSelection/success/text': {
    en: 'Your entry was submitted successfully. Good luck!',
    fr: 'Votre participation a été soumise avec succès. Bonne chance!',
  },
  'notifications/tierSelection/error/text': {
    en: 'An unknown error has occurred. Please please try again later or contact support.',
    fr: 'Une erreur inconnue est survenue. Veuillez réessayer plus tard ou contacter le service de soutien.',
  },
  'notifications/gameplay/success/text': {
    en: 'No purchase necessary, gameplay request submitted.',
    fr: 'Demande de participation sans achat soumise.',
  },
  'notifications/reminders/header': {
    en: 'Do you want to turn on notifications?',
    fr: 'Voulez-vous activer les notifications?',
  },
  'notifications/reminders/body': {
    en: 'This will allow you to receive ongoing game reminders and stay informed on your progress throughout the season.',
    fr: 'Vous recevrez des rappels concernant les matchs et pourrez consulter vos progrès tout au long de la saison.',
  },
  'notifications/reminders/text': {
    en: 'I’d like reminders about upcoming games and prizes I’ve won.',
    fr: 'Je souhaite recevoir des rappels concernant les matchs à venir et les prix que j’ai gagnés.',
  },
  'notifications/reminders/button': {
    en: 'Next',
    fr: 'Suivant',
  },
  'notifications/error/playnow/text': {
    en: 'We’re having trouble displaying today’s games. Please check back later.',
    fr: 'Nous éprouvons des difficultés à afficher les parties du jour. Veuillez revenir plus tard.',
  },
  'notifications/errormodal/header': {
    en: 'Sorry, we ran into an issue',
    fr: 'Nous sommes désolés, un problème est survenu',
  },
  'notifications/errormodal/text': {
    en: 'We’re having trouble loading the game for you. Please try again later.',
    fr: 'Un problème est survenu lors du chargement du Défi. Veuillez réessayer plus tard.',
  },
  'notifications/errormodal/button': {
    en: 'Okay',
    fr: 'Ok',
  },
  'notifications/incompletePicks/title': {
    en: "Don't forget to submit your picks!",
    fr: "N'oubliez pas de soumettre vos choix!",
  },
  'notifications/incompletePicks/text': {
    en: "You haven't submitted your picks yet, are you sure you want to leave?",
    fr: "Vous n'avez pas encore soumis vos choix, voulez-vous vraiment quitter?",
  },
  'notifications/incompletePicks/leaveButton': {
    en: 'Leave',
    fr: 'Quitter',
  },
  'notifications/incompletePicks/cancelButton': {
    en: 'Cancel',
    fr: 'Annuler',
  },
  'notifications/picks/submission/error/title': {
    en: 'Something went wrong',
    fr: 'Une erreur est survenue',
  },
  'notifications/picks/submission/error/text': {
    en: "Sorry, your picks couldn't be submitted. Please try again.",
    fr: "Désolé, vos sélections n'ont pas été enregistrées. Veuillez réessayer.",
  },
};

export default strings;
